import AxiosInstance from "../instance";
import {emptyFn, returnValidResponse} from "../utils";

const getMemeFonts = async () => {
    const response = await AxiosInstance.getInstance().get("/groupapi/meme/fonts").catch(emptyFn);
    return returnValidResponse(response);
};

const getMemeImages = async () => {
    const response = await AxiosInstance.getInstance().get("/groupapi/meme/images").catch(emptyFn);
    return returnValidResponse(response);
};

interface IGeneratedMeme {
    image: string;
    topText: string;
    bottomText: string;
    font: string;
    fontSize: number;
};

const getGeneratedMeme = async (data: IGeneratedMeme) => {
    const response = await AxiosInstance.getInstance().get("/groupapi/meme", {
        params: {
            meme: data.image,
            top: data.topText,
            bottom: data.bottomText,
            font: data.font,
            font_size: data.fontSize
        },
        responseType: "blob"
    });
    return response;
};

export {
    getGeneratedMeme,
    getMemeImages,
    getMemeFonts
};


// WEBPACK FOOTER //
// ./src/api/models/MemeGenerator.ts